module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/sp-review-bfabaa77d5f4ec3305e6a09328b15778.webp";